import { render, staticRenderFns } from "./LpuPopupMap.vue?vue&type=template&id=3cdd1d2e&"
import script from "./LpuPopupMap.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuPopupMap.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cdd1d2e')) {
      api.createRecord('3cdd1d2e', component.options)
    } else {
      api.reload('3cdd1d2e', component.options)
    }
    module.hot.accept("./LpuPopupMap.vue?vue&type=template&id=3cdd1d2e&", function () {
      api.rerender('3cdd1d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPopupMap.vue"
export default component.exports